import { Link } from 'react-router-dom';
import { useState } from 'react';
import { merchantsService } from '../services/api';
import StatusBadge from './shared/StatusBadge';

function Merchants({ mockUsers, user, onMerchantsUpdate }) {
  const [pciFilter, setPciFilter] = useState('All');
  const [salesFilter, setSalesFilter] = useState('All');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newMerchant, setNewMerchant] = useState({
    id: '',
    name: '',
    email: '',
    mid: '',
    businessName: '',
    contact: '',
    contactPhone: '',
    totalSales: 0,
    transactions: 0,
    pciCompliant: false,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  console.log('Merchants component - mockUsers:', mockUsers);

  const filteredMerchants = mockUsers.filter((merchant) => {
    const matchesPci =
      pciFilter === 'All' ||
      (pciFilter === 'Compliant' && merchant.pciCompliant) ||
      (pciFilter === 'Non-Compliant' && !merchant.pciCompliant);
    const matchesSales =
      salesFilter === 'All' ||
      (salesFilter === '< $5000' && merchant.totalSales < 5000) ||
      (salesFilter === '$5000-$7500' && merchant.totalSales >= 5000 && merchant.totalSales <= 7500) ||
      (salesFilter === '> $7500' && merchant.totalSales > 7500);
    return matchesPci && matchesSales;
  });

  console.log('Filtered merchants after PCI and sales filters:', filteredMerchants);

  const handleCreateMerchant = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    if (!newMerchant.id || !newMerchant.name || !newMerchant.email || !newMerchant.mid || !newMerchant.businessName || !newMerchant.contact || !newMerchant.contactPhone) {
      setError('All fields are required');
      setLoading(false);
      return;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newMerchant.email)) {
      setError('Invalid email format');
      setLoading(false);
      return;
    }
  
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(newMerchant.contactPhone)) {
      setError('Phone number must be in the format 555-123-4567');
      setLoading(false);
      return;
    }
  
    try {
      const merchantData = {
        id: newMerchant.id,
        role: 'merchant',
        name: newMerchant.name,
        parentId: user.id,
        email: newMerchant.email,
        mid: newMerchant.mid,
        businessName: newMerchant.businessName,
        contact: newMerchant.contact,
        contactPhone: newMerchant.contactPhone,
        totalSales: newMerchant.totalSales,
        transactions: newMerchant.transactions,
        pciCompliant: newMerchant.pciCompliant,
      };
      
      // Services return data directly now
      const response = await merchantsService.createMerchant(merchantData);
    
      console.log('Created merchant:', response);
      alert('Merchant created successfully!');
      setShowCreateForm(false);
      setNewMerchant({
        id: '',
        name: '',
        email: '',
        mid: '',
        businessName: '',
        contact: '',
        contactPhone: '',
        totalSales: 0,
        transactions: 0,
        pciCompliant: false,
      });
    
      // Call parent callback to refresh merchants list if provided
      if (onMerchantsUpdate) {
        onMerchantsUpdate();
      } else {
        // Fallback: refresh the merchants list
        const usersResponse = await merchantsService.getMerchants();
        // Better pattern: use a callback from parent instead of direct mutation
        if (Array.isArray(mockUsers)) {
          mockUsers.length = 0;
          mockUsers.push(...usersResponse);
        }
      }
    } catch (err) {
      setError('Failed to create merchant: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-800">Merchants</h2>
      <div className="flex justify-between items-center mb-4">
        <div className="flex flex-col md:flex-row md:space-x-4">
          <div className="mb-2 md:mb-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">PCI Compliance</label>
            <select
              value={pciFilter}
              onChange={(e) => setPciFilter(e.target.value)}
              className="border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand w-full md:w-auto"
            >
              <option value="All">All</option>
              <option value="Compliant">Compliant</option>
              <option value="Non-Compliant">Non-Compliant</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Total Sales</label>
            <select
              value={salesFilter}
              onChange={(e) => setSalesFilter(e.target.value)}
              className="border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand w-full md:w-auto"
            >
              <option value="All">All</option>
              <option value="< $5000">&lt; $5000</option>
              <option value="$5000-$7500">$5000-$7500</option>
              <option value="> $7500">&gt; $7500</option>
            </select>
          </div>
        </div>
        {user.role === 'so' && (
          <button
            onClick={() => setShowCreateForm(!showCreateForm)}
            className="px-3 py-2 rounded-md text-gray-800 bg-brand hover:bg-brand-hover text-sm font-semibold transition-colors"
            disabled={loading}
          >
            {showCreateForm ? 'Cancel' : 'Create Merchant'}
          </button>
        )}
      </div>

      {showCreateForm && (
        <form onSubmit={handleCreateMerchant} className="mb-4 p-4 bg-gray-100 rounded-lg">
          <h3 className="text-lg font-medium mb-4 text-gray-700">Create New Merchant</h3>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">ID</label>
              <input
                type="text"
                value={newMerchant.id}
                onChange={(e) => setNewMerchant({ ...newMerchant, id: e.target.value })}
                placeholder="merchant5"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <input
                type="text"
                value={newMerchant.name}
                onChange={(e) => setNewMerchant({ ...newMerchant, name: e.target.value })}
                placeholder="Merchant Name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={newMerchant.email}
                onChange={(e) => setNewMerchant({ ...newMerchant, email: e.target.value })}
                placeholder="merchant@example.com"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">MID#</label>
              <input
                type="text"
                value={newMerchant.mid}
                onChange={(e) => setNewMerchant({ ...newMerchant, mid: e.target.value })}
                placeholder="MID-XXX"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Business Name</label>
              <input
                type="text"
                value={newMerchant.businessName}
                onChange={(e) => setNewMerchant({ ...newMerchant, businessName: e.target.value })}
                placeholder="Business Name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contact Name</label>
              <input
                type="text"
                value={newMerchant.contact}
                onChange={(e) => setNewMerchant({ ...newMerchant, contact: e.target.value })}
                placeholder="Contact Name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contact Phone</label>
              <input
                type="text"
                value={newMerchant.contactPhone}
                onChange={(e) => setNewMerchant({ ...newMerchant, contactPhone: e.target.value })}
                placeholder="555-123-4567"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">PCI Compliant</label>
              <select
                value={newMerchant.pciCompliant}
                onChange={(e) => setNewMerchant({ ...newMerchant, pciCompliant: e.target.value === 'true' })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand"
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`mt-4 px-4 py-2 rounded-md text-gray-800 font-semibold ${loading ? 'bg-gray-400' : 'bg-brand hover:bg-brand-hover'} transition-colors`}
          >
            {loading ? 'Creating...' : 'Create Merchant'}
          </button>
        </form>
      )}

      <div className="bg-white p-4 md:p-6 rounded-lg shadow-md overflow-x-auto">
        {filteredMerchants.length === 0 ? (
          <p className="text-gray-500">No merchants found.</p>
        ) : (
          <table className="w-full border-separate border-spacing-0 min-w-[600px]">
            <thead>
              <tr className="bg-gray-100">
                <th className="border-t border-l border-r border-gray-200 p-2 md:p-3 text-left text-xs md:text-sm font-semibold text-gray-600 uppercase rounded-tl-lg">Name</th>
                <th className="border-t border-l border-r border-gray-200 p-2 md:p-3 text-left text-xs md:text-sm font-semibold text-gray-600 uppercase">MID#</th>
                <th className="border-t border-l border-r border-gray-200 p-2 md:p-3 text-left text-xs md:text-sm font-semibold text-gray-600 uppercase">PCI Compliance</th>
                <th className="border-t border-l border-r border-gray-200 p-2 md:p-3 text-left text-xs md:text-sm font-semibold text-gray-600 uppercase rounded-tr-lg">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredMerchants.map((merchant, index) => (
                <tr key={merchant._id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="border-t border-l border-r border-gray-200 p-2 md:p-3">{merchant.name}</td>
                  <td className="border-t border-l border-r border-gray-200 p-2 md:p-3">{merchant.mid}</td>
                  <td className="border-t border-l border-r border-gray-200 p-2 md:p-3">
                    <StatusBadge 
                      type="compliance_status" 
                      value={merchant.pciCompliant}
                      size="xs"
                    />
                  </td>
                  <td className="border-t border-l border-r border-gray-200 p-2 md:p-3">
                    <Link
                      to={`/merchants/${merchant._id}`}
                      className="text-brand hover:text-brand-hover text-sm font-medium"
                    >
                      View Merchant
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Merchants;